import React, {FC} from 'react';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/components/trans';
import {AppContentTypesEnum} from '../../../../libs/shared/core/src/store/panels/app/commonAppPanelState';
import {
  ContactCardPanelId,
  ContactDetailsPanelId,
} from '../../../../libs/shared/core/src/store/panels/panelStateBase';
import {OkCancelDialog} from '../../../../libs/shared/ui/src/components/dialogs/okCancelDialog';
import {useAppDispatch} from '../../../helpers/appReduxHelpers';
import {ApplicationEntryPointActionTypesEnum} from '../../../models/api/applicationEntryPointActionModel';
import {ApplicationContactEntryPointModel} from '../../../models/api/applicationEntryPointModel';
import {activateContactEntryPointAction} from '../../../store/data/applications/selectedSideFrameIdActions';
import {pushContentTypeAction} from '../../../store/panels/app/appPanelRouteActions';

interface NavigateToPluginDialogProps {
  onRequestClose: () => void;
  contactEntryPoint?: ApplicationContactEntryPointModel;
  handle?: string;
  panelId?: ContactCardPanelId | ContactDetailsPanelId;
}

export const NavigateToPluginDialog: FC<NavigateToPluginDialogProps> = (props) => {
  const {contactEntryPoint, handle, panelId, onRequestClose} = props;
  const dispatch = useAppDispatch();

  if (!contactEntryPoint || !handle || !panelId) {
    return null;
  }

  // Currently, we only support contact handle entry points that open side panel.
  if (contactEntryPoint.action?.type !== ApplicationEntryPointActionTypesEnum.OPEN_SIDE_PANEL) {
    throw new Error(`We only support contact handle entry points that open the side panel.`);
  }

  return (
    <OkCancelDialog
      title={<Trans id="navigate-to-plugin-title">Go to {contactEntryPoint.name} plugin</Trans>}
      okButtonLabel={<Trans id="navigate-to-plugin-continue">Continue</Trans>}
      onRequestClose={onRequestClose}
      onOkClick={() => {
        dispatch(activateContactEntryPointAction(contactEntryPoint, handle, panelId));
        onRequestClose();
        dispatch(pushContentTypeAction(panelId, AppContentTypesEnum.INBOXES));
      }}
    >
      <Trans id="navigate-to-plugin-dialog-body">
        Click &#39;Continue&#39; to leave the page and go to the {contactEntryPoint.name} plugin in the inbox.
      </Trans>
    </OkCancelDialog>
  );
};
